<template>
  <div class="orders-container">
    <el-card class="full-height-card">
      <div slot="header" class="header-container">
        <span>充值订单</span>
      </div>
      
      <!-- 搜索表单 -->
      <el-form :inline="true" :model="searchForm" class="search-form">
        <el-form-item>
          <el-input v-model="searchForm.username" placeholder="用户" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="searchForm.payOrderId" placeholder="支付订单号" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="searchForm.status" placeholder="状态" clearable>
            <el-option label="处理中" :value="0"></el-option>
            <el-option label="已完成" :value="1"></el-option>
            <el-option label="已失败" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">搜索</el-button>
          <el-button @click="resetSearch">重置</el-button>
        </el-form-item>
      </el-form>
      
      <!-- 移动端卡片列表 -->
      <div class="mobile-cards" v-if="isMobile">
        <el-card v-for="order in orderList" :key="order.id" class="mobile-card">
          <div class="card-header">
            <span class="order-id">订单号: {{ order.id }}</span>
            <el-tag :type="getStatusType(order.status)" size="small">
              {{ getStatusText(order.status) }}
            </el-tag>
          </div>
          <div class="card-content">
            <div class="info-item">
              <span class="label">支付订单ID：</span>
              <span>{{ order.payOrderId }}</span>
            </div>
            <div class="info-item">
              <span class="label">用户：</span>
              <span>{{ order.username }}</span>
            </div>
            <div class="info-item">
              <span class="label">充值金额：</span>
              <span>{{ order.amount.toFixed(4) }} USDT</span>
            </div>
            <div class="info-item">
              <span class="label">充值地址：</span>
              <span>{{ order.address }}</span>
              <el-button 
              v-if="order.address" 
              type="text" 
              icon="el-icon-picture-outline" 
              @click.stop="showQrCode(order.address)">
              二维码
            </el-button>
            </div>
            <div class="info-item">
              <span class="label">备注：</span>
              <span>{{ order.remark || '无' }}</span>
            </div>
            <div class="info-item">
              <span class="label">创建时间：</span>
              <span>{{ formatDate(order.createTime) }}</span>
            </div>
          </div>
          <div class="card-footer">
            <el-button-group>
              <el-button 
                v-if="order.status === 0"
                size="mini" 
                type="success" 
                @click="handleAllow(order)">通过</el-button>
              <el-button 
                v-if="order.status === 0"
                size="mini" 
                type="danger" 
                @click="handleReject(order)">拒绝</el-button>
              <el-button
                size="mini"
                @click="handleDetail(order)">详情</el-button>
              <el-button
                v-if="order.status != 0"
                type="danger"
                size="mini"
                @click="deleteDetail(order)">删除</el-button>
            </el-button-group>
          </div>
        </el-card>
      </div>
      
      <!-- PC端表格 -->
      <el-table
        v-else
        v-loading="loading"
        :data="orderList"
        border
        height="calc(100vh - 240px)"
        style="width: 100%">
        <el-table-column
          prop="id"
          label="ID"
          width="120">
        </el-table-column>
        <el-table-column
          prop="payOrderId"
          label="支付订单ID"
          width="220">
        </el-table-column>
        <el-table-column
          prop="username"
          label="用户"
          width="80">
        </el-table-column>
        <el-table-column
          prop="amount"
          label="充值金额"
          width="120">
          <template slot-scope="scope">
            {{ scope.row.amount.toFixed(4) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="address"
          label="充值地址"
          width="220">
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.address" placement="top" effect="light">
              <span>{{ scope.row.address ? (scope.row.address.length > 15 ? scope.row.address.substring(0, 15) + '...' : scope.row.address) : '无' }}</span>
            </el-tooltip>
            <el-button 
              v-if="scope.row.address" 
              type="text" 
              icon="el-icon-picture-outline" 
              @click.stop="showQrCode(scope.row.address)">
              二维码
            </el-button>
          </template>
        </el-table-column>
        <el-table-column
          prop="status"
          label="状态"
          width="100">
          <template slot-scope="scope">
            <el-tag :type="getStatusType(scope.row.status)">
              {{ getStatusText(scope.row.status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注"
          width="180">
          <template slot-scope="scope">
            {{ scope.row.remark }}
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="创建时间"
          width="180">
          <template slot-scope="scope">
            {{ formatDate(scope.row.createTime) }}
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="180"
          fixed="right">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.status === 0"
              size="mini"
              type="success"
              @click="handleAllow(scope.row)">通过</el-button>
            <el-button
              v-if="scope.row.status === 0"
              size="mini"
              type="danger"
              @click="handleReject(scope.row)">拒绝</el-button>
            <el-button
              size="mini"
              @click="handleDetail(scope.row)">详情</el-button>

              <el-button
              type="danger"
              size="mini"
              v-if="scope.row.status != 0"
              @click="deleteDetail(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      
      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total">
        </el-pagination>
      </div>
    </el-card>
    
    <!-- 订单详情对话框 -->
    <el-dialog title="充值订单详情" :visible.sync="detailDialogVisible" width="600px">
      <el-descriptions :column="2" border>
        <el-descriptions-item label="订单ID">{{ currentOrder.id }}</el-descriptions-item>
        <el-descriptions-item label="支付订单ID">{{ currentOrder.payOrderId }}</el-descriptions-item>
        <el-descriptions-item label="用户ID">{{ currentOrder.userId }}</el-descriptions-item>
        <el-descriptions-item label="订单号">{{ currentOrder.orderId }}</el-descriptions-item>
        <el-descriptions-item label="充值金额">
          {{ currentOrder.amount ? currentOrder.amount.toFixed(4) : '' }}
        </el-descriptions-item>
        <el-descriptions-item label="充值地址" :span="2">
          <div class="address-detail">
            <span>{{ currentOrder.address }}</span>
            <el-button 
              v-if="currentOrder.address" 
              type="text" 
              icon="el-icon-picture-outline" 
              @click="showQrCode(currentOrder.address)">
              查看二维码
            </el-button>
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="状态">
          <el-tag :type="getStatusType(currentOrder.status)">
            {{ getStatusText(currentOrder.status) }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="备注" v-if="currentOrder.remark">
          {{ currentOrder.remark }}
        </el-descriptions-item>
        <el-descriptions-item label="是否删除">
          <el-tag :type="currentOrder.deleted === 0 ? 'success' : 'danger'">
            {{ currentOrder.deleted === 0 ? '正常' : '已删除' }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="创建时间" :span="2">{{ formatDate(currentOrder.createTime) }}</el-descriptions-item>
      </el-descriptions>
      <div slot="footer" class="dialog-footer">
        <el-button @click="detailDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>

     <!-- 拒绝原因对话框 -->
     <el-dialog title="拒绝原因" :visible.sync="rejectDialogVisible" width="500px">
      <el-form :model="rejectForm" ref="rejectForm">
        <el-form-item label="拒绝原因" prop="remark" :rules="[{ required: true, message: '请输入拒绝原因', trigger: 'blur' }]">
          <el-input type="textarea" v-model="rejectForm.remark" rows="4" placeholder="请输入拒绝原因"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="rejectDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleRefuse" :loading="submitLoading">确定</el-button>
      </div>
    </el-dialog>

    <!-- 二维码对话框 -->
    <el-dialog title="地址二维码" :visible.sync="qrCodeDialogVisible" width="300px" center>
      <div class="qrcode-container">
        <div ref="qrCodeContainer" class="qrcode"></div>
        <div class="qrcode-address">{{ currentAddress }}</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import QRCode from 'qrcodejs2'

export default {
  name: 'DepositOrders',
  data() {
    return {
      loading: false,
      orderList: [],
      searchForm: {
        username: '',
        payOrderId: '',
        status: ''
      },
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      rejectForm: {
        id: null,
        remark: ''
      },
      rejectDialogVisible: false,
      submitLoading: false,
      detailDialogVisible: false,
      currentOrder: {},
      qrCodeDialogVisible: false,
      currentAddress: '',
      qrCode: null,
      isMobile: false
    }
  },
  methods: {
    // 获取订单列表
    fetchOrderList() {
      this.loading = true
      
      const params = {
        pageNum: this.pagination.pageNum,
        pageSize: this.pagination.pageSize,
        username: this.searchForm.username || undefined,
        payOrderId: this.searchForm.payOrderId || undefined,
        status: this.searchForm.status !== '' ? this.searchForm.status : undefined
      }
      
      axios.get('/recharge/order/page', { params })
        .then(response => {
          this.loading = false
          const { data } = response.data
          
          this.orderList = data.data
          this.pagination.total = data.total
          this.pagination.pageNum = data.pageNum
          this.pagination.pageSize = data.pageSize
        })
        .catch(error => {
          this.loading = false
          const errorMsg = error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : '网络错误，请稍后重试'
          this.$message.error(errorMsg)
          console.error('获取充值订单列表失败:', error)
        })
    },

     // 拒绝提现申请
     handleReject(row) {
      this.rejectForm.id = row.id
      this.rejectForm.remark = ''
      this.rejectDialogVisible = true
    },
    
    // 通过充值订单
    handleAllow(row) {
      this.$confirm(`确认通过用户 ${row.username} 的充值订单?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        axios.post(`/balance/recharge/approve/`+row.id, { id: row.id })
          .then(response => {
            if (response.data.status === 200) {
              this.$message.success('操作成功')
              this.fetchOrderList() // 刷新列表
            } else {
              this.$message.error(response.data.message || '操作失败')
            }
          })
          .catch(error => {
            const errorMsg = error.response && error.response.data && error.response.data.message
              ? error.response.data.message
              : '网络错误，请稍后重试'
            this.$message.error(errorMsg)
            console.error('处理提现申请失败:', error)
          })
      }).catch(() => {
        // 取消操作
      })
    },
    
    // 拒绝充值订单
    handleRefuse(row) {
      this.$refs.rejectForm.validate(valid => {
        if (valid) {
          this.submitLoading = true
          
          axios.post('/balance/recharge/reject', this.rejectForm)
            .then(response => {
              this.submitLoading = false
              this.rejectDialogVisible = false
              
              if (response.data.status === 200) {
                this.$message.success('操作成功')
                this.fetchOrderList() // 刷新列表
              } else {
                this.$message.error(response.data.message || '操作失败')
              }
            })
            .catch(error => {
              this.submitLoading = false
              const errorMsg = error.response && error.response.data && error.response.data.message
                ? error.response.data.message
                : '网络错误，请稍后重试'
              this.$message.error(errorMsg)
              console.error('拒绝提现申请失败:', error)
            })
        }
      })
    },
    
    // 搜索
    handleSearch() {
      this.pagination.pageNum = 1
      this.fetchOrderList()
    },
    
    // 重置搜索
    resetSearch() {
      this.searchForm.userId = ''
      this.searchForm.orderId = ''
      this.searchForm.status = ''
      this.handleSearch()
    },
    
    // 处理页码变化
    handleCurrentChange(pageNum) {
      this.pagination.pageNum = pageNum
      this.fetchOrderList()
    },
    
    // 处理每页条数变化
    handleSizeChange(pageSize) {
      this.pagination.pageSize = pageSize
      this.pagination.pageNum = 1
      this.fetchOrderList()
    },
    
    // 查看订单详情
    handleDetail(row) {
      this.currentOrder = { ...row }
      this.detailDialogVisible = true
    },

    
     // 查看订单详情
     deleteDetail(row) {

      this.$confirm(`确认删除用户 ${row.username} 的充值订单?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        axios.delete(`/recharge/order/${row.id}`)
          .then(response => {
            if (response.data.status === 200) {
              this.$message.success('操作成功')
              this.fetchOrderList() // 刷新列表
            } else {
              this.$message.error(response.data.message || '操作失败')
            }
          })
          .catch(error => {
            const errorMsg = error.response && error.response.data && error.response.data.message
              ? error.response.data.message
              : '网络错误，请稍后重试'
            this.$message.error(errorMsg)
            console.error('通过充值订单失败:', error)
          })
      }).catch(() => {
        // 取消操作
      })

    },
    
    // 获取状态类型
    getStatusType(status) {
      switch (status) {
        case 0:
          return 'warning' // 处理中
        case 1:
          return 'success' // 已完成
        case 2:
          return 'danger' // 已失败
        default:
          return 'info'
      }
    },
    
    // 获取状态文本
    getStatusText(status) {
      switch (status) {
        case 0:
          return '处理中'
        case 1:
          return '已完成'
        case 2:
          return '已失败'
        default:
          return '未知'
      }
    },
    
    // 格式化日期
    formatDate(dateStr) {
      if (!dateStr) return '未知'
      
      const date = new Date(dateStr)
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`
    },

    // 显示二维码
    showQrCode(address) {
      this.currentAddress = address
      this.qrCodeDialogVisible = true
      
      this.$nextTick(() => {
        // 清除旧的二维码
        if (this.qrCode) {
          this.$refs.qrCodeContainer.innerHTML = ''
        }
        
        // 生成新的二维码
        this.qrCode = new QRCode(this.$refs.qrCodeContainer, {
          text: address,
          width: 200,
          height: 200,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H
        })
      })
    },

    // 检查是否为移动端
    checkMobile() {
      this.isMobile = window.innerWidth <= 768
    }
  },
  created() {
    this.checkMobile()
    window.addEventListener('resize', this.checkMobile)
    this.fetchOrderList()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile)
  }
}
</script>

<style scoped>
.orders-container {
  padding: 20px;
}

.header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.search-form {
  margin-bottom: 20px;
}

.pagination-container {
  margin-top: 20px;
  text-align: right;
}

.dialog-footer {
  text-align: right;
}

.address-detail {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.qrcode-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.qrcode {
  margin-bottom: 15px;
}

.qrcode-address {
  font-size: 12px;
  word-break: break-all;
  text-align: center;
  max-width: 200px;
}

/* 移动端卡片样式 */
.mobile-cards {
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding: 10px 0;
}

.mobile-card {
  margin-bottom: 10px;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #ebeef5;
}

.order-id {
  font-size: 16px;
  font-weight: bold;
  color: #303133;
}

.card-content {
  margin: 15px 0;
}

.info-item {
  margin-bottom: 12px;
  font-size: 14px;
  line-height: 1.5;
  word-break: break-all;
}

.label {
  color: #909399;
  margin-right: 8px;
  font-weight: 500;
}

.card-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 15px;
  padding-top: 10px;
  border-top: 1px solid #ebeef5;
}

/* 响应式布局 */
@media screen and (max-width: 768px) {
  .orders-container {
    padding: 10px;
  }
  
  .search-form {
    display: flex;
    flex-direction: column;
  }
  
  .search-form .el-form-item {
    margin-right: 0;
    margin-bottom: 10px;
  }
  
  .pagination-container {
    margin-top: 15px;
  }
  
  .el-pagination {
    text-align: center;
  }
  
  .card-footer {
    flex-direction: column;
    gap: 10px;
  }
  
  .card-footer .el-button-group {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
  }
  
  .card-footer .el-button-group .el-button {
    margin-right: 0;
  }
  
  .mobile-card {
    margin: 0 0 15px 0;
  }
  
  .mobile-card .el-card__body {
    padding: 15px;
  }
  
  .info-item {
    margin-bottom: 10px;
  }
  
  .info-item:last-child {
    margin-bottom: 0;
  }
}
</style> 